import { render } from "./WCAutoHeightTransition.vue?vue&type=template&id=4791acf5&scoped=true"
import script from "./WCAutoHeightTransition.vue?vue&type=script&lang=js"
export * from "./WCAutoHeightTransition.vue?vue&type=script&lang=js"

import "./WCAutoHeightTransition.vue?vue&type=style&index=0&id=4791acf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4791acf5"]])

export default __exports__